export default __webpack_public_path__ + "static/media/L.ea143452.svg";